import React from "react";
import styles from "./StartsFromCard.module.scss";
import Text from "@components/atoms/Text";
import Image from "next/image";
import { StartsFromCardProps } from "./StartsFromCard.types";
import { formatToLakhs } from "@utils/numberFormatter";
import assetLoader from "@utils/internalImageLoder";

export default function StartsFromCard({
  variants,
  type,
  startsFrom,
  onClick,
}: StartsFromCardProps) {
  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.titleContainer}>
        <Text className={styles.variants}>{variants}</Text>
        <Text className={styles.type}>{type} variants</Text>
      </div>
      <div className={styles.priceContainer}>
        <Text className={styles.price}>
          Starts from{" "}
          <span className={styles.priceValue}>{startsFrom}</span>
        </Text>
        <Image
          src={`${assetLoader()}/icons/Arrow_right.svg`}
          alt={"right"}
          width={20}
          height={20}
          loading="lazy"
          className={styles.arrowIcon}
        />
      </div>
    </div>
  );
}
